export enum CalculationEventEnum {
  ErrorsBadgeClicked = 'calculation.errors.badge_clicked',
  // Published when an item is removed from a form array (e.g. a child). The calculation
  // form re-validates so the error list no longer references the removed element.
  FormArrayItemDeleted = 'calculation.form.array_item_deleted',
}